import {render} from 'react-dom';
import routes from './routes';
import './index.css';
import 'bootstrap/dist/css/bootstrap.css';

render(routes, document.getElementById('root'));



// WEBPACK FOOTER //
// ./src/index.js